import styled from 'styled-components'

export const StyledMap = styled.div`
  width: 100%;
  height: 100%;

  & > div {
    z-index: 1;
  }

  .leaflet-tooltip-right {
    margin-left: ${props => props.theme.spacing.large};
    background-color: ${props => props.theme.colors.secondary[500]};
    color: #fff;
    border-radius: ${props => props.theme.radius.normal};
    padding: ${props => props.theme.spacing.small} ${props => props.theme.spacing.default};
    border: 0;
    box-shadow: unset;
    font-size: ${props => props.theme.font.small};

    &:before {
      display: none;
    }
  }
`
